import React from 'react'

import {makeStyles} from '@material-ui/styles'

const isHide = props =>
  (props.inline ||
    (
      !props.title
      &&
      !props.label
    )
  )

const marginTopLabel = 10
const marginTopNoLabel = 0
const BorderTopLabel = 0
const borderTopNoLabel = 3

const useStylesAdornment = (props) => makeStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      borderTopLeftRadius: (isHide(props) || !(props.value && props.value !== 'NULL' ? props.value : '') ? borderTopNoLabel : BorderTopLabel),
      marginTop: (isHide(props) ? marginTopNoLabel : marginTopLabel),
      '&.Mui-focused': {
        borderTopLeftRadius: (isHide(props) || !(props.value && props.value !== 'NULL' ? props.value : '') ? borderTopNoLabel : BorderTopLabel),
        marginTop: (isHide(props) ? marginTopNoLabel : marginTopLabel),
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderTopLeftRadius: (isHide(props) || !(props.value && props.value !== 'NULL' ? props.value : '') ? borderTopNoLabel : BorderTopLabel),
      '&.Mui-focused': {
        borderTopLeftRadius: (isHide(props) || !(props.value && props.value !== 'NULL' ? props.value : '') ? borderTopNoLabel : BorderTopLabel),
      },
    },
  }
})

// Our hook
export default (props) => {
  return props.classes || useStylesAdornment(props)()
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Hook/useStyle/Input.js